import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const timeseriesChartDescription: CalculatorDescription = {
  id: CalculatorId.TimeseriesChart,
  title: 'Time Series Chart Maker',
  metaTitle: 'Online Time Series Chart Maker - Create Time-Based Visualizations',
  description: 'Create professional time series charts to visualize data trends over time. Perfect for tracking metrics, analyzing patterns, and visualizing temporal data.',
  metaDescription: 'Make professional time series charts online. Visualize temporal data with our free time series chart generator. Perfect for tracking metrics, analyzing trends, and visualizing patterns over time.',
  howTo: {
    title: 'How to Create a Time Series Chart',
    steps: [
      'Select your time-based column (dates, timestamps)',
      'Choose one or more value columns to plot',
      'Customize appearance with markers and area fills',
      'Use zoom controls to focus on specific time periods',
      'Set title and finalize visualization'
    ],
    graphic: {
      description: 'An echarts time series chart with interactive zooming, time-based axis, and multiple data series'
    }
  },
  examples: [
    {
      title: 'Business Metrics Tracking',
      description: 'Track KPIs over time',
      dataDescription: 'Revenue, user growth, and other metrics over months/years',
      insights: [
        'Monitor growth trends',
        'Identify seasonal patterns',
        'Compare metrics over time',
        'Spot anomalies'
      ]
    },
    {
      title: 'Performance Analysis',
      description: 'System performance monitoring',
      dataDescription: 'CPU usage, memory, response times over time',
      insights: [
        'Track system health',
        'Identify peak usage',
        'Monitor resource usage',
        'Detect performance issues'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.LineChart,
    CalculatorId.AreaChart,
    CalculatorId.BarGraph,
    CalculatorId.ScatterChart
  ]
}; 